import React from 'react';
import { ChevronDown } from 'tabler-icons-react';

export function LowPriorityIcon() {
  return <ChevronDown color="#2e8540" size={20} />;
}
